module.exports = __webpack_public_path__ + "img/project-collapse.14a90a65.svg";